
import { defineComponent } from 'vue'
import UserService from '../common/userService'
import User from '../models/user'
import { debounce } from 'lodash'

export default defineComponent({
  name: 'Users',

  data () {
    return {
      /** The username to search on */
      newUserUsername: '',

      /** Indicates that a user search is in process */
      searchingForUser: false,

      /** Indicator to show or hide the new user form */
      shouldShowNewUserForm: false,

      /** The result of the user search */
      userResult: null as unknown as User | null,

      /** The list of users */
      users: [] as Array<User>
    }
  },

  mounted () {
    // Load the current users
    UserService.getOspStaff().then(res => {
      this.users = res.data
    })
  },

  watch: {
    // Perform a debounced search when the username input chagnes
    newUserUsername: function (username: string) {
      this.userResult = null

      if (username !== '') {
        this.searchingForUser = true
        this.debouncedSearch(username)
      } else {
        this.searchingForUser = false
      }
    }
  },

  methods: {
    /**
     * Performs a debounced search for a user
     * @param username: The username to search on
     */
    debouncedSearch: debounce(function (this: { search }, username: string) {
      this.search(username)
    }, 1000),

    /**
     * Adds the user found via search as an OSP staff member
     */
    addOspStaff () {
      if (this.userResult) {
        UserService.createOspStaff(this.userResult.username).then(res => {
          this.users.push(res.data)
          this.resetNewUserForm()
        })
      }
    },

    /**
     * Returns's a comma separated list of a user's permissions
     * @param user: Tthe user
     */
    permissionString (user: User) {
      return user.permissions.map(p => p.name).join(', ')
    },

    /**
     * Removes OSP Staff status from the given user
     * @param user: The user to remove
     */
    removeUser (user: User) {
      if (window.confirm('Are you sure?')) {
        UserService.removeOspStaff(user.id).then(() => {
          const ind = this.users.findIndex(u => u.id === user.id)
          this.users.splice(ind, 1)
        })
      }
    },

    /**
     * Resets the new user form
     */
    resetNewUserForm () {
      this.newUserUsername = ''
      this.shouldShowNewUserForm = false
    },

    /**
     * Performs a search for a user given a username
     * @param username: The username to search on
     */
    search (username: string) {
      UserService.searchUser(username).then(res => {
        this.userResult = res.data
        this.searchingForUser = false
      }).catch(() => {
        this.userResult = null
        this.searchingForUser = false
      })
    }
  }
})
